import { Video } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useFeatureToggles } from '@/hooks/useFeatureToggles';
import { cn } from '@/lib/utils';

/** Aide VisionPOS, ouverte directement sur l'onglet « Tutoriels Vidéo ». */
export const TUTOS_VIDEO_PATH = '/tutoriels?onglet=videos';

type TutorialsLinkProps = {
  className?: string;
};

/**
 * Lien « Voir les tutos vidéo » des bandeaux du haut (app et caisse).
 * Masqué si le flag `aide_videos` est désactivé pour le commerce.
 */
export function TutorialsLink({ className }: TutorialsLinkProps) {
  const { isFeatureEnabled } = useFeatureToggles();
  if (!isFeatureEnabled('aide_videos')) return null;

  return (
    <Button
      asChild
      variant="ghost"
      size="sm"
      className={cn('h-8 gap-1.5 px-2 text-primary', className)}
    >
      <Link to={TUTOS_VIDEO_PATH} title="Voir les tutos vidéo" data-testid="tutos-video-link">
        <Video className="h-4 w-4" />
        <span className="hidden whitespace-nowrap sm:inline">Voir les tutos vidéo</span>
      </Link>
    </Button>
  );
}
